var Config = {
  LIMIT: 10,
  PERSIST_SECRET_KEY: "APP_REDUX_PERSIST_STORE_KEY",
  // Targets the staging server this repo is being deployed to. Switch to
  // PRODUCTION for a prod build, or LOCAL when running against a backend
  // on your own machine.
  //
  // create-react-app inlines process.env.REACT_APP_* at BUILD time, so both of
  // these are fixed the moment the image is built and cannot be changed by
  // restarting the container — changing which API the console talks to means
  // rebuilding. docker-compose.staging.yml passes them through as build args.
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || "STAGING",
  ENVIRONMENTS: {
    LOCAL: {
      API_URL: "http://localhost:8080/v1",
      GOOGLE_API_KEY: "APP_GOOGLE_API_KEY",
      // MCAP now lives at its own origin — its own repo, its own container.
      // This console no longer renders the dashboard itself, and no longer
      // links to it either; the value is kept because the backend's MCAP
      // digest email links there. LOCAL only: this literal is never used by a
      // deployed build, which substitutes APP_MCAP_APP_URL below. Default
      // matches that app's own `npm start` port.
      MCAP_APP_URL: process.env.REACT_APP_MCAP_APP_URL || "http://localhost:3002",
    },
    // APP_API_URL / APP_MCAP_APP_URL are placeholders substituted at deploy
    // time by the pipeline's replace-env-vars step, not literal values.
    DEVELOPMENT: {
      API_URL: "APP_API_URL",
      GOOGLE_API_KEY: "APP_GOOGLE_API_KEY",
      MCAP_APP_URL: "APP_MCAP_APP_URL",
    },
    // The literal below is the OLD Bitbucket/Kodefuse QA host. It is kept only
    // so an unconfigured build behaves exactly as the previous deployment did.
    // A new staging server must set REACT_APP_API_URL (see ADMIN_API_URL in
    // docker-compose.staging.yml) or the console will talk to the old backend.
    STAGING: {
      API_URL: process.env.REACT_APP_API_URL || "https://api-aou-qa.kodefuse.com/v1",
      GOOGLE_API_KEY: "APP_GOOGLE_API_KEY",
      MCAP_APP_URL: process.env.REACT_APP_MCAP_APP_URL || "",
    },
    // REACT_APP_API_URL first, same as STAGING. The literal is the fixed host
    // this build used before and stays only as that fallback:
    // docker-compose.production.yml requires ADMIN_API_URL, so a compose build
    // never reaches it.
    PRODUCTION: {
      API_URL: process.env.REACT_APP_API_URL || "https://api.mindcircuit.org/v1",
      GOOGLE_API_KEY: "APP_GOOGLE_API_KEY",
      MCAP_APP_URL: process.env.REACT_APP_MCAP_APP_URL || "",
    },
  },
};

Config.env = () => {
  return Config.ENVIRONMENTS[Config.ENVIRONMENT];
};

export default Config;
